import { TaskTimeFrame } from './types'

export const scheduleFields = [
  'from_ts',
  'deadline',
  'frequency_time',
  'is_recurring',
  'monthly_range',
  'recurrence_frequency',
  'days_of_week',
  'allowed_overdue_days',
  'review_to_ts',
] as const
export function getScheduleValues(values: Record<string, any>): TaskTimeFrame {
  return scheduleFields.reduce((result, name) => ({ ...result, [name]: values[name] }), {} as TaskTimeFrame)
}
export type SettingsSection =
  | 'audience'
  | 'auditors'
  | 'watchers'
  | 'view'
  | 'schedule'
  | 'priority'
  | 'advanced'
  | 'extension'
export function getMissingSettings(values: Record<string, any>, isVmTask: boolean): SettingsSection[] {
  const missing: SettingsSection[] = []

  if (!['groups', 'users', 'tags'].some((key) => values.audience?.[key]?.length)) missing.push('audience')
  if (isVmTask && !values.auditors?.length) missing.push('auditors')
  if (typeof values.view !== 'number') missing.push('view')
  if (!values.from_ts || !values.deadline || values.allowed_overdue_days === '' || values.allowed_overdue_days == null)
    missing.push('schedule')
  return missing
}

/** Map actual registered errors to section navigation without duplicating field validation rules. */
export function getInvalidSettings(
  values: Record<string, any>,
  errors: Record<string, any>,
  isVmTask: boolean
): SettingsSection[] {
  const invalid = getMissingSettings(values, isVmTask)

  if (scheduleFields.some((name) => !!errors[name]) && !invalid.includes('schedule')) invalid.push('schedule')
  if (Object.keys(errors).some((name) => !['audience', 'auditors', 'view', ...scheduleFields].includes(name)))
    invalid.push('advanced')
  return invalid
}
